import { useCallback, useEffect, useState } from 'react'
import {
  Backdrop,
  CircularProgress,
  Grid,
  makeStyles,
  Avatar,
  Divider,
  Typography
} from '@material-ui/core'
import { getProduct } from '../../api/products.service'
import SaveOrCancelButtons from '../../components/saveOrCancelButtons'
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined'
import ResourceList from '../../components/Resources/ResourceList'
import imgNotFound from '../../assets/img/imagen_no_disponible.jpeg'
import { DialogTitle } from '../../components/DialogTitle'

const dataKeyNames = {
  eanCode: 'Código EAN',
  providerMainCode: 'Código principal de proveedor',
  description1: 'Descripción',
  description2: 'Descripción ampliada',
  size: 'Tamaño',
  measurementUnit: 'Unidad de medida',
  pack: 'Pack',
  alternativePack: 'Pack alternativo',
  vatRate: 'Porcentaje IVA',
  equivalenceSurchargeRate: 'Porcentaje REQ',
  grossWeight: 'Peso bruto',
  volume: 'Volúmen',
  volumetricWeight: 'Peso volumétrico',
  lifespan: 'Vida útil',
  temperature: 'Temperatura',
  providerBox: 'Caja proveedor',
  isActive: 'Activo',
  isExclusive: 'Exclusivo',
  allergens: 'Alérgenos',
  additionalInfo: 'Información adicional',
  videoUrl: 'Enlace a vídeo'
}

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  title: {
    justifySelf: 'end',
    margin: '-5px 15px 20px 5px'
  },
  rowTitle: {
    marginRight: 8,
    marginBottom: 4,
    fontWeight: 'bold',
    fontSize: 14
  },
  rowText: {
    fontSize: 18,
    maxWidth: 280
  },
  imagePreview: {
    maxWidth: '300px',
    maxHeight: '300px',
    minWidth: '250px',
    minHeight: '250px',
    objectFit: 'contain'
  }
}))

const ProductDetails = (props) => {
  const classes = useStyles()

  const productId = props.id
  const handleClose = props.onClose

  const [loading, setLoading] = useState(false)

  const [stateForm, setStateForm] = useState({})

  const getData = useCallback(() => {
    setLoading(true)
    getProduct(productId).then((result) => {
      const allergens = result.data.allergens
        .map((allergen) => {
          return (
            ` ${allergen.allergen}` + (allergen.component !== '' ? ` (${allergen.component})` : '')
          )
        })
        .toString()

      result.data = {
        ...result.data,
        additionalInfo: result.data.additionalInfo === null ? '' : result.data.additionalInfo,
        videoUrl: result.data.videoUrl === null ? '' : result.data.videoUrl,
        allergens: allergens,
        isActive: result.data.isActive ? 'SI' : 'NO',
        isExclusive: result.data.isExclusive ? 'SI' : 'NO'
      }

      setStateForm(result.data)
      setLoading(false)
    })
  }, [productId])

  useEffect(() => {
    if (productId !== undefined && productId !== null) {
      getData()
    }
  }, [productId, getData])

  const Title = (_) => <h2>Detalle del artículo: {productId}</h2>

  return (
    <div>
      <Grid container direction="column">
        <DialogTitle title={<Title />} />
        <Grid item>
          <Grid container direction="row" spacing={2}>
            <Grid item xs={12}>
              {stateForm.imageUrl !== undefined &&
              stateForm.imageUrl !== null &&
              stateForm.imageUrl !== '' ? (
                <img
                  className={classes.imagePreview + ' d-flex mx-auto'}
                  alt={`img-product-${stateForm.id}`}
                  src={stateForm.imageUrl}
                  onError={(event) => {
                    event.currentTarget.onerror = null
                    event.currentTarget.src = imgNotFound
                  }}
                />
              ) : (
                <Avatar
                  className={classes.imagePreview + ' bg-primary mx-auto '}
                  variant="rounded"
                  style={{ width: 150, height: 150 }}
                >
                  <ImageOutlinedIcon style={{ fontSize: 125 }} />
                </Avatar>
              )}
            </Grid>
            {Object.entries(stateForm).map((entry) => {
              if (dataKeyNames[entry[0]] && !!entry[1] && entry[1] !== '') {
                return (
                  <Grid
                    key={`product-${entry[0]}`}
                    item
                    xs={12}
                    sm={6}
                    lg={4}
                    style={{ wordBreak: 'break-word' }}
                  >
                    <Typography
                      color="primary"
                      variant="body1"
                    >{`${dataKeyNames[entry[0]]}:`}</Typography>
                    <Typography variant="body1">{entry[1]}</Typography>
                  </Grid>
                )
              }
              return ''
            })}
            <Grid item xs={12}>
              <Typography color="primary" variant="body1">
                Documentos del artículo:
              </Typography>
              <Divider />
            </Grid>
            <Grid item xs={12} md={6}>
              <ResourceList resources={stateForm.documents} />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <SaveOrCancelButtons onSave={false} onCancel={handleClose} loading={loading} />
          </Grid>
        </Grid>
      </Grid>
      <Backdrop className={classes.backdrop} open={loading} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

export default ProductDetails
